export default {
  title: 'Termíny',
  heading: 'Hlídač termínů',
  subtitle: 'Hlídáme za vás důležité termíny spojené s vedením SVJ.',

  addAction: 'Přidat termín',
  emptyState: 'Zatím tu nejsou žádné termíny.',
  isLoading: 'Načítáme termíny…',

  tip: {
    title: 'Tip: pohlídáme vám i vaše vlastní termíny',
    text: 'Doporučujeme přidat všechny důležité termíny týkající se vašeho SVJ – revize, výročí pojistné smlouvy, konec platnosti PENB a další. Na blížící se termíny vás pak upozorníme.',
    action: 'Přidat termín',
  },

  lock: {
    title: 'Narazili jste na placenou funkci aplikace',
    text: 'Hlídač termínů za vás pohlídá zákonné povinnosti SVJ – vyúčtování služeb, shromáždění, revize a další. Přidáte si i vlastní termíny a na všechny důležité vás včas upozorníme e-mailem, abyste na nic nezapomněli. Funkce je součástí plné verze aplikace.',
  },

  notificationSetting: {
    label: 'Zasílat mi e-mailová upozornění na blížící se termíny',
    note: 'Upozorňujeme 30 dní a 7 dní předem a v den termínu – pouze u termínů s běžnou a vysokou prioritou. Na termíny s nízkou prioritou e-maily neposíláme. Nastavení platí jen pro vás, ostatní správci si ho řídí sami.',
    successOn: 'E-mailová upozornění jsou zapnutá.',
    successOff: 'E-mailová upozornění jsou vypnutá.',
  },

  yearGroups: {
    thisYear: 'Letos ({{year}})',
    nextYear: 'Příští rok ({{year}})',
    later: 'Později',
    older: 'Starší',
    count_one: '{{count}} termín',
    count_few: '{{count}} termíny',
    count_other: '{{count}} termínů',
  },

  summary: {
    overdue: 'Po termínu',
    soon: 'Do 30 dní',
    upcoming: 'Nadcházející',
    completed: 'Splněno',
  },

  filter: {
    all: 'Vše',
    pending: 'Nesplněné',
    completed: 'Hotové',
  },

  relative: {
    today: 'dnes',
    inDays_one: 'za {{count}} den',
    inDays_few: 'za {{count}} dny',
    inDays_other: 'za {{count}} dní',
    inMonths_one: 'za {{count}} měsíc',
    inMonths_few: 'za {{count}} měsíce',
    inMonths_other: 'za {{count}} měsíců',
    inYears_one: 'za {{count}} rok',
    inYears_few: 'za {{count}} roky',
    inYears_other: 'za {{count}} let',
    overdueDays_one: 'po termínu o {{count}} den',
    overdueDays_few: 'po termínu o {{count}} dny',
    overdueDays_other: 'po termínu o {{count}} dní',
    overdueMonths_one: 'po termínu o {{count}} měsíc',
    overdueMonths_few: 'po termínu o {{count}} měsíce',
    overdueMonths_other: 'po termínu o {{count}} měsíců',
    overdueYears_one: 'po termínu o {{count}} rok',
    overdueYears_few: 'po termínu o {{count}} roky',
    overdueYears_other: 'po termínu o {{count}} let',
    completedAt: 'splněno {{date}}',
    recurring: 'opakuje se každý rok',
  },

  actions: {
    complete: 'Hotovo',
    undo: 'Vrátit',
    edit: 'Upravit',
    delete: 'Smazat',
  },

  category: {
    revision: 'Revize',
    document: 'Dokument',
    finance: 'Finance',
    legal: 'Právní',
    meeting: 'Shromáždění',
    other: 'Ostatní',
  },

  priority: {
    low: 'Nízká',
    normal: 'Běžná',
    high: 'Vysoká',
  },

  Modal: {
    createTitle: 'Nový termín',
    editTitle: 'Úprava termínu',
    deleteTitle: 'Smazat termín',
    deleteConfirmText: 'Opravdu chcete tento termín smazat?',
    deleteConfirm: 'Ano, smazat',
    Fields: {
      template: { label: 'Šablona', placeholder: 'Vyberte šablonu (nepovinné)' },
      title: { label: 'Název', placeholder: 'Např. Revize výtahu' },
      dueDate: { label: 'Termín' },
      category: { label: 'Kategorie', placeholder: 'Vyberte kategorii' },
      priority: { label: 'Priorita' },
      note: { label: 'Poznámka', placeholder: 'Nepovinná poznámka' },
      submitCreate: 'Přidat termín',
      submitEdit: 'Uložit změny',
    },
  },

  Flash: {
    successAdd: 'Termín byl přidán.',
    successEdit: 'Termín byl upraven.',
    successDelete: 'Termín byl smazán.',
    successComplete: 'Termín byl označen jako splněný.',
    successUndo: 'Termín byl vrácen mezi nesplněné.',
    error: 'Něco se nepovedlo. Zkuste to prosím znovu.',
  },
};
